import { render } from "./ModalComponent.vue?vue&type=template&id=32a0a834&scoped=true"
import script from "./ModalComponent.vue?vue&type=script&lang=js"
export * from "./ModalComponent.vue?vue&type=script&lang=js"

import "@/assets/css/general/modal-style.css?vue&type=style&index=0&id=32a0a834&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a0a834"]])

export default __exports__